import React from 'react'
import Select from 'components/select'
import { OptionProps } from 'types'

interface Props {
  onChange: (option: string) => void
  onMultipleChange: (options: string[]) => void
  tags: OptionProps[]
  name: string
  selectedTags: string[]
  keyword: string
}

const VariablesSelect: React.FC<Props> = ({ onChange, onMultipleChange, tags, name, selectedTags, keyword }) => {
  return (
    <div className="bg-surface transition-all rounded flex-1 min-w-[200px] mt-0 mb-2.5 mr-2.5 ml-0">
      <div className="flex items-center mb-2.5 pb-2 border-b-2 border-b-divider">
        <div className="flex items-center w-full h-full">
          <div className="font-semibold text-[90%]">{`${name} ${keyword}`}</div>
        </div>
      </div>
      <Select
        options={tags}
        optionsSelected={selectedTags}
        groupBy={true}
        multiselect={true}
        onOptionClick={(option) => onChange(option)}
        setOptionsSelected={(options) => onMultipleChange(options)}
      />
    </div>
  )
}

export default VariablesSelect
